import { createStyles, makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() =>
  createStyles({
    image: { margin: '25px 0' },
  }),
);

export default useStyles;
